module.exports = __webpack_public_path__ + "img/setsign.7978b724.png";